import { render, staticRenderFns } from "./FreeEvaluationChannel.vue?vue&type=template&id=59ccaf82&scoped=true"
import script from "./FreeEvaluationChannel.vue?vue&type=script&lang=js"
export * from "./FreeEvaluationChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ccaf82",
  null
  
)

export default component.exports